import { useTranslate } from "@tolgee/react";
import { useTrackTeaserProductVideoOpenedMutation } from "api/analitics";
import { useSession } from 'context/session';
import { Videos } from "new-architecture/components/videos";
import { FC, memo, useCallback, useMemo } from "react";
import { Container } from "react-bootstrap";
import { PropertyTeaserType } from "store/properties/types";
import { PropertySecurityInfoItems } from "./property-security-info-items";
import { PropertySecutityInfoTitle } from "./property-secutity-info-title";

import style from "./style.module.scss";

type PropertySecurityInfoProps = {
  property: PropertyTeaserType;
}

const emptyValue = 'N/A';

export const PropertySecurityInfo: FC<PropertySecurityInfoProps> = memo(
  ({ property }) => {
    const { securityAndRoles: { security = [] }, options, sectionAssets } = property;
    const { securityInformation: securityInformationVideos } = sectionAssets || {};
    const { user } = useSession();
    const { t: tOpportunityCard } = useTranslate('opportunity_card');

    const values = useMemo(() => {
      const out = [...security];
      
      out.push(
        {
          name: 'ISIN',
          value: options?.isin || emptyValue
        }
      );

      out.push(
        {
          name: tOpportunityCard('opportunity_card.relinc_price'),
          // value: isVerifiedFinancialAdvisor && options?.relincPrice ? options.relincPrice : emptyValue
          value: user ? options.relincPrice || emptyValue : emptyValue
        }
      );

      return out;
    }, [options.isin, options.relincPrice, security, tOpportunityCard, user]);

    const [trackProductVideoOpened] = useTrackTeaserProductVideoOpenedMutation();
    const onOpenVideo = useCallback((videoUrl: string) => {
      trackProductVideoOpened({
        opportunity: property.name,
        opportunityId: property._id,
        productVideoUrl: videoUrl
      });
    }, [trackProductVideoOpened, property]);

    return (
      <div className="bg-bgLight">
        <div>
          <Container>
            <div className={style["security-info__container"]}>
              <PropertySecutityInfoTitle />
              <Videos videos={securityInformationVideos || []} onOpenVideo={onOpenVideo} />
              <PropertySecurityInfoItems info={values} />
            </div>
          </Container>
        </div>
      </div>
    );
  }
);
